export { default } from './SkeletonFaresGridBackgroundImage';
